// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__aGg4n","errorLogs":"EditorFooter_errorLogs__2PQTX"};